import API from '../../../helpers/request/api';

const api = () => new API();

const getList = (communityId) => {
  const query = {
    query: `{ community_badges(community_id: "${communityId}")
      {
        id
        name
        medal_color
        tie_color
        description
        icon {
          icon
        }
        community_badge_image_url
        created_at
        updated_at
      }
    }`,
  };

  return api().get(query);
};

export default {
  getList,
};



// WEBPACK FOOTER //
// ./src/screens/Community/queries/badge.js